jQuery(document).ready(function($) {

    isSmallMobile = {
        any: function() {
            return $(window).width() < 767;
        }
    };

    //HOMEPAGE HEADER SCROLL
    if(jQuery(window).width() > 1025) {
		if ( $("body").hasClass( "home" ) ) {
			$(window).scroll(function() {
		        var scrollTop = $(window).scrollTop();
		        if( scrollTop >= 100 )
		        {
		          $('#header').addClass('scroll-header');
		        }
		        else
		        {
		          $('#header').removeClass('scroll-header');
		        }
		    });
		}
	};



    //HEADER SEARCH TOGGLE
	$('.search-toggle-button, .search-field').on('click', function () {
		$('#search-toggle').toggleClass('active');
		$('#menu-toggle').removeClass('active');
		$('#menu-top-menu > .menu-item').removeClass('active');
		$('#search-toggle #searchform #alg-search').focus();
		$('#alg-search').typeahead('close');
	});
	//END OF HEADER SEARCH TOGGLE


   var owl1 = jQuery(".model-carousel").owlCarousel({
        autoPlay: 4000,
        navigation: true,
        items: 3,
        itemsDesktop: [1024, 3],
        itemsDesktopSmall: [979, 2],
        itemsTablet: [768, 2],
        itemsMobile: [550, 1],
        beforeMove : function() {
          // lazyload hidden owl carousel items when they come into view
          if (typeof LazyLoad === "function") {
            var myLazyLoad = new LazyLoad();
          }
        }
    });

       var owl2 = jQuery(".gallery-container").owlCarousel({
        autoPlay: 4000,
        navigation: true,
        items: 3,
        itemsDesktop: [1024, 3],
        itemsDesktopSmall: [979, 2],
        itemsTablet: [768, 2],
        itemsMobile: [550, 1],
        beforeMove : function() {
          // lazyload hidden owl carousel items when they come into view
          if (typeof LazyLoad === "function") {
            var myLazyLoad = new LazyLoad();
          }
        }
    });

    var reviews =  $("#review-box").owlCarousel({
        autoPlay: 7000,
        slideSpeed: 1000,
        navigation: false,
        navigationText: [
          "", ""
        ],
        items : 1,
        itemsDesktop : [1024,1],
        itemsDesktopSmall: [979,1],
        itemsTablet: [767,1],
		itemsMobile: [320,1],
        beforeMove : function() {
            if (typeof LazyLoad === "function") {
                var myLazyLoad = new LazyLoad();
            }
        }
    });

    $(".next").click(function(){
		reviews.trigger('owl.next');
	})
	$(".prev").click(function(){
		reviews.trigger('owl.prev');
	})


    //BOOTSTRAP SEARCH FILTERS
    jQuery(document).ready(function($){
    //SEARCH DROPDOWNS
    if ($(window).width() > 767) {
            $("#homepage-advanced-search select").selectpicker({
                dropupAuto: false
            });
            $("body").on('search_filters_rendered', function () {
                $("#homepage-advanced-search select").selectpicker('refresh');
            });
        }
    });


    //CTABOX PREMIUM OPTIONS
    $('#ctabox-premium-features .features-link').click(function() {
    	$(this).parent().toggleClass('open');
    });

    $("body").on("vrp-ready vrp-ajax-complete", function() {
        $(".vehicle").each(function() {
            $(this).find(".fancy.button-form.button.cta-button").insertAfter( $(".price-top", this) );
        });
    });
//00274521 add search to mobile vrp
    $('#results-page #search-anything').removeClass('hidden-xs');
//end 00274521

    // 00481056
    if ($(window).width() <= 767) {
        $("body").on("vrp-ready vrp-ajax-complete",function(){
            $(".vehicle.new-vehicle").each(function() {
                $(this).find($('.online-shopper-cta-box')).appendTo($(this).find(".after_pricing-action-links"));
            }); 
        });
      } else {
        $("body").on("vrp-ready vrp-ajax-complete",function(){
            $(".vehicle.new-vehicle").each(function() {
                $(this).find($('.online-shopper-cta-box')).appendTo($(this).find(".vehicle-price.after-vehicle-price"));
            }); 
        });
      };
    //end 00481056

});

